import {UniversalListSettings} from "./universal-list";

export class StocksToolbarSettingsMain{
    constructor(){

    }

    public showDataWorkOnGridChanges?: boolean
}

export class StocksToolbarSettings {
    constructor(public zoneName: string, public position) {
        this.zoneStyles = {};
        this.canHideOnExpand = false;
    }

    public zoneClickFunction: (val?: any) => void;
    public zoneClickFunctionName: string;
    public buttons: StocksToolbarButtonsSettings[];
    public zoneStyles: {[key: string]: any | null};
    public zoneId: string;
    public canHideOnExpand: boolean;
    public hide: boolean;
    public expanded: boolean;
    public openToolBarOnClick: boolean;
    public set pointer (val: boolean){
        this.zoneStyles.cursor = val ? 'pointer' : 'none';
    }
}



export class StocksToolbarButtonsSettings {
    constructor( ) {
        this.btnStyles = {};
        this.btnInStyles = {};
        this.disabled = false;
    }

    public buttonClickFunction: (val: any) => void;
    public universalListSettings: UniversalListSettings;
    public buttonId: string;
    public type: string;
    public grouping: Slick.Data.GroupingOptions<any>[];
    public showList: boolean;
    public unData: any[];
    public buttonName: string;
    public buttonTitle: string;
    public btnStyles: {[key: string]: any | null};
    public btnInStyles: {[key: string]: any | null};
    public disabled: boolean;
    public opened: boolean;
    public selected: boolean;

    public set setStyles(val: {[key: string]: any | null}){
        if (val){
            this.btnStyles = val;
        }
    };

    public set setStyles2(val: {[key: string]: any | null}){
        if (val){
            this.btnInStyles = val;
        }
    };



}



// WEBPACK FOOTER //
// ./src/app/shared/models/stocks-toolbar-settings.ts